import type { TagsListTexts } from '@/forms-legacy'
import { intl } from '@/intl'

export function tagsRenderText(
  field: TagsListTexts,
  _,
  collapsed?: boolean,
  count?: number,
  filter?: string,
) {
  switch (field) {
    case 'addTag':
      return intl.translate({
        id: 'vehicles.form.edit.generalSettings.badges.addBadge',
      })

    case 'suggestedListTitle':
      return intl.translate({
        id: 'vehicles.form.edit.generalSettings.badges.suggestedBadges',
      })

    case 'searchPlaceholder':
      return intl.translate({
        id: 'vehicles.form.edit.generalSettings.badges.searchPlaceholder',
      })

    case 'loadMoreTag':
      const hasCount = typeof count === 'number'
      if (hasCount) {
        return intl.translate({
          id: 'vehicles.form.edit.generalSettings.badges.loadMore',
          values: { count },
        })
      }
      return intl.translate({
        id: 'global.loadMore',
      })

    case 'suggestionsListMessage':
      return intl.translate({
        id: 'vehicles.form.edit.generalSettings.badges.suggestionsListMessage',
      })

    case 'noResult':
      return intl.translate({
        id: 'vehicles.form.edit.generalSettings.badges.noResult',
        values: { filter: filter || '' },
      })

    case 'maxCountReached':
      return intl.translate({
        id: 'vehicles.form.edit.generalSettings.badges.maxCountReached',
      })

    case 'noTags':
      return intl.translate({
        id: 'vehicles.form.edit.generalSettings.badges.noBadges',
      })

    case 'bulkTitle':
      return ''

    case 'addToAll':
      return ''

    case 'tagsListMessage':
      return intl.translate({
        id: 'vehicles.form.edit.generalSettings.badges.badgesList',
      })

    case 'remove':
      const countText = typeof count === 'number' ? `(${count})` : ``
      return intl.translate({
        id: 'vehicles.form.edit.generalSettings.badges.remove',
        values: { count: countText },
      })

    case 'toggleVisibility':
      return collapsed
        ? intl.translate({
            id: 'global.show',
          })
        : intl.translate({
            id: 'global.hide',
          })
    default:
      return field
  }
}
